import React, { useState, useEffect, useMemo } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
} from "@mui/material";
import { useTranslation } from "react-i18next";

import { JsonForms } from "@jsonforms/react";
import { materialCells } from "@jsonforms/material-renderers";
import { materialRenderers } from "../jsonForms/materialRenderers.jsx";
import ButtonLoader from "../ButtonLoader.jsx";
import { useFormAction } from "../../form.jsx";

import * as api from "../../services/api";
import { status } from "shared/src/appointment.mjs";
import { toStructuredFields } from "../client/AppointmentServices.jsx";
import { useAuthData } from "../../context/AuthenticationTokenContext.jsx";
const HandoverAppointmentTemplate = ({ onClose, serviceId, appointmentId }) => {
  const authData = useAuthData();
  const fetchTemplate = async () => {
    api
      .fetchTemplateByServiceId(serviceId)
      .then(({ data }) => {
        setTemplate(data.templateByServiceId);
      })
      .catch((error) => {
        console.error("Error loading service template:", error);
      });
  };

  const { loading, onSubmit } = useFormAction(
    async () => {
      const createTemplateResult = api.createFilledServiceTemplate({
        appointment_id: appointmentId,
        template_id: template.id,
        filled_data: {
          fields: toStructuredFields({
            cleanedData: formState,
            jsonSchema: template.template.schema,
            uiSchema: template.template.uischema,
          }),
        },
      });
      const patchResult = api.patchAppointment({
        id: appointmentId,
        status_id: status.FINISHED,
        employee_id: authData.id,
      });
      return Promise.all([createTemplateResult, patchResult]);
    },
    () => {
      onClose();
    },
  );

  const [template, setTemplate] = useState(null);

  useEffect(() => {
    if (serviceId) {
      fetchTemplate();
    }
  }, [serviceId]);

  const { t, i18n } = useTranslation();

  const translation = useMemo(
    () => (key, defaultMessage) => {
      return i18n.exists(`serviceTemplates:${key}`)
        ? t(`serviceTemplates:${key}`)
        : defaultMessage;
    },
    [i18n.language],
  );
  const [formState, setFormState] = React.useState({});
  const handleFormChange = (data) => {
    setFormState(data);
  };
  const [formSubmitted, setFormSubmitted] = React.useState(false);

  return (
    <Dialog
      open={serviceId}
      onClose={onClose}
      maxWidth="md"
      fullWidth
      slotProps={{
        paper: {
          component: "form",
          onSubmit: onSubmit,
        },
      }}
    >
      <DialogTitle>Zápis</DialogTitle>
      <DialogContent>
        {template && (
          <JsonForms
            schema={JSON.parse(template.template.schema)}
            uischema={JSON.parse(template.template.uischema)}
            data={formState}
            renderers={materialRenderers}
            cells={materialCells}
            onChange={({ data }) => handleFormChange(data)}
            config={{ forceShow: formSubmitted }}
            i18n={{ translate: translation }}
          />
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button
          variant="contained"
          type="submit"
          disabled={loading}
          onClick={() => {
            setFormSubmitted(true);
          }}
        >
          {loading && <ButtonLoader />}
          {t("form.submit")}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default HandoverAppointmentTemplate;
